<template>
    <div class="el-form-item" :class="{
    'is-error': validateState === 'error',
    'is-validating': validateState === 'validating',
    'is-required': isRequired || required
  }">
        <label class="el-form-item-label" :style="labelStyle" v-if="label">
            {{label + form.labelSuffix}}
        </label>
        <div class="el-form-item-content" :style="contentStyle">
            <slot></slot>
            <transition name="md-fade-bottom">
                <div class="el-form-item-error" v-if="validateState === 'error'">{{validateMessage}}</div>
            </transition>
        </div>
    </div>
</template>
<script>
    import AsyncValidator from 'async-validator';
    import emitter from '../../../utils/emitter';

    function noop() {

    }

    function getPropByPath(obj,path) {
        let tempObj = obj;
        path = path.replace(/\[(\w+)\]/g, '.$1');
        path = path.replace(/^\./, '');

        let keyArr = path.split('.');
        let i = 0;

        for (let len = keyArr.length; i < len - 1; ++i) {
            let key = keyArr[i];
            if (key in tempObj) {
                tempObj = tempObj[key];
            } else {
                throw new Error('please transfer a valid prop path to form item!');
            }
        }
        return {
            o: tempObj,
            k: keyArr[i],
            v: tempObj[keyArr[i]]
        };

    }

    export default {
        name: 'ElFormItem',

        componentName: 'form-item',

        mixins: [emitter],

        props: {
            label: String,
            labelWidth: String,
            prop: String,
            required: Boolean,
            rules: [Object, Array],
            error:String,
            validateStatus:String
        },
        watch:{
            error(value){
                this.validateMessage = value;
                this.validateState = 'error';
            },
            validateStatus(value){
                this.validateState = value;
            }
        },
        computed: {
            labelStyle() {
                var ret = {};
                var labelWidth = this.labelWidth || this.form.labelWidth;
                if (labelWidth) {
                    ret.width = labelWidth;
                }
                return ret;
            },
            contentStyle() {
                var ret = {};
                var labelWidth = this.labelWidth || this.form.labelWidth;
                if (labelWidth) {
                    ret.marginLeft = labelWidth;
                }
                return ret;
            },
            form() {
                var parent = this.$parent;
                while (parent.$options.componentName !== 'form') {
                    parent = parent.$parent;
                }
                return parent;
            },
            fieldValue: {
                cache: false,
                get() {
                    var model = this.form.model;
                    if (!model || !this.prop) { return; }

                    var path = this.prop;

                    if(path.indexOf(':') !== -1){
                        path = path.replace(/:/,'.');
                    }

                    return getPropByPath(model,path).v;
                }
            }
        },
        data() {
            return {
                validateState: '',
                validateMessage: '',
                validateDisabled: false,
                validator: {},
                isRequired: false
            };
        },
        methods: {
            validate(trigger, cb = noop) {
                var rules = this.getFilteredRule(trigger);
                if (!rules || rules.length === 0) {
                    cb();
                    return true;
                }

                this.validateState = 'validating';

                var descriptor = {};
                descriptor[this.prop] = rules;

                var validator = new AsyncValidator(descriptor);
                var model = {};

                model[this.prop] = this.fieldValue;

                validator.validate(model, { firstFields: true }, (errors, fields) => {
                    this.validateState = !errors ? 'success' : 'error';
                    this.validateMessage = errors ? errors[0].message : '';

                    cb(errors);
                });
            },
            resetField() {
                this.validateState = '';
                this.validateMessage = '';

                let model = this.form.model;
                let value = this.fieldValue;
                let path = this.prop;
                if (path.indexOf(':') !== -1) {
                    path = path.replace(/:/, '.');
                }

                let prop = getPropByPath(model, path);

                if (Array.isArray(value) && value.length > 0) {
                    this.validateDisabled = true;
                    prop.o[prop.k] = [];
                } else if (value) {
                    this.validateDisabled = true;
                    prop.o[prop.k] = this.initialValue;
                }
            },
            getRules() {
                var formRules = this.form.rules;
                var selfRuels = this.rules;

                formRules = formRules ? formRules[this.prop] : [];

                return [].concat(selfRuels || formRules || []);
            },
            getFilteredRule(trigger) {
                var rules = this.getRules();

                return rules.filter(rule => {
                    return !rule.trigger || rule.trigger.indexOf(trigger) !== -1;
                });
            },
            onFieldBlur() {
                this.validate('blur');
            },
            onFieldChange() {
                if (this.validateDisabled) {
                    this.validateDisabled = false;
                    return;
                }

                this.validate('change');
            }
        },
        mounted() {
            if (this.prop) {
                this.dispatch('form', 'el.form.addField', [this]);

                Object.defineProperty(this, 'initialValue', {
                    value: this.fieldValue
                });


                let rules = this.getRules();

                if (rules.length) {
                    rules.every(rule => {
                        if (rule.required) {
                            this.isRequired = true;
                            return false;
                        }
                    });
                    this.$on('el.form.blur', this.onFieldBlur);
                    this.$on('el.form.change', this.onFieldChange);
                }
            }
        },
        beforeDestroy() {
            this.dispatch('form', 'el.form.removeField', [this]);
        }
    };
</script>



// WEBPACK FOOTER //
// form-item.vue?82d42ce6